export const modalWithdrawStatusMessage: boolean = true;
